// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
// const { initializeAppCheck, ReCaptchaV3Provider } = require("firebase/app-check");

const firebaseConfig = {
  apiKey: "AIzaSyDeJFNEGXs-8_EcEGi0cLuNni9v9xiO_xs",
  authDomain: "gdscglau-recruitment-portal.firebaseapp.com",
  databaseURL: "https://gdscglau-recruitment-portal-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "gdscglau-recruitment-portal",
  storageBucket: "gdscglau-recruitment-portal.appspot.com",
  messagingSenderId: "664393678172",
  appId: "1:664393678172:web:25fb74627bf6299a1b1599",
  measurementId: "G-780Z07PELT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// const appCheck = initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider('6Ld-ge8gAAAAAPO5KCcfg5lKegt65FJJTUOAZicz'),

//   // Optional argument. If true, the SDK automatically refreshes App Check
//   // tokens as needed.
//   isTokenAutoRefreshEnabled: true
// });
export const firestore = getFirestore(app);
export default app;